import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Handshake, Building2, TrendingUp, ShieldCheck, FileText, Briefcase } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const operations = [{
  title: "Segreti Commerciali",
  description: "Supporto legale per la protezione di segreti industriali e know-how attraverso clausole di riservatezza e non concorrenza evolute.",
  icon: ShieldCheck
}];
export default function ExtraordinaryOperations() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="operazioni-straordinarie" ref={ref} className="dark bg-background text-foreground relative py-24 overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/dark_leather_texture.png')] bg-cover bg-center opacity-10 mix-blend-overlay pointer-events-none" />
      <div className="absolute inset-0 bg-gradient-to-b from-background via-background/95 to-background pointer-events-none" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className={`max-w-3xl mx-auto text-left mb-16 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="font-medium tracking-tight mb-12 text-foreground font-sans uppercase text-6xl">PRIVACY E TUTELA DEI DATI</h2>
  <p className="text-lg text-muted-foreground leading-relaxed text-left md:text-justify md:text-xl">
    In un mondo in cui la protezione dei dati personali, la Cybersecurity e l’Intelligenza Artificiale rappresentano sfide e opportunità sempre più centrali per aziende di ogni dimensione, affidarsi a un partner legale competente è fondamentale. DCLegal si distingue come punto di riferimento per le imprese offrendo consulenza specializzata nell’adeguamento alle normative europee in ambito protezione dei dati e nell’implementazione di strategie efficaci per la tutela della privacy e la sicurezza delle informazioni. Il nostro team di professionisti accompagna il management aziendale in tutte le fasi della gestione dei dati personali e delle nuove tecnologie, con servizi che includono:
</p>

<ul className="list-none space-y-2 my-6 text-lg text-muted-foreground md:text-xl ml-2">
    <li>• Redazione e aggiornamento del Registro dei Trattamenti</li>
    <li>• Data Privacy Impact Assessment</li>
    <li>• Predisposizione di informative e nomine</li>
    <li>• Definizione e revisione delle procedure privacy</li>
    <li>• Analisi delle misure di sicurezza</li>
    <li>• Analisi e adeguamento dei siti web</li>
    <li>• Supporto alle attività di marketing</li>
</ul>

<p className="text-lg text-muted-foreground leading-relaxed text-left md:text-justify md:text-xl">
    Inoltre, i nostri esperti ricoprono il ruolo di <strong>Data Protection Officer (DPO)</strong> per numerose realtà, assicurando un presidio costante e aggiornato sugli sviluppi normativi e tecnologici.
</p>
 

        </div>

        
      </div>
    </section>;
}